import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import { Track } from "../../types";
import InterestsTab from ".";

function InterestsMobileTab({
  open,
  onClose,
  track,
}: Readonly<{
  open: boolean;
  onClose: () => void;
  track: Track;
}>) {
  return (
    <FullPageModal isOpen={open} onClose={onClose} title="Interests">
      <InterestsTab propertyUid={track.property.uid} />
    </FullPageModal>
  );
}

export default InterestsMobileTab;
